import React, { useState } from 'react';
import { createContext } from 'react';
import { getRequestsByDatesAndMisdn, getRequestsByDatesAndMeter } from '../service/requestService';
import { toast } from 'react-toastify';

export const MainContext = createContext();

export const MainContextProvider = (props) => {
   const [requests, setRequests] = useState([]);
   const [loadingRequest, isLoadingRequest] = useState(false);

   const fetchRequests = async (formatedStartDate, formatedEndDate, searchKey, searchValue) => {
      try {
         isLoadingRequest(true);
         const result = await getRequestsByDatesAndMisdn(formatedStartDate, formatedEndDate, searchKey, searchValue, 50);
         const requestData = await result.data.data;
         if (requestData.length === 0) {
            toast.info('No Records found', { autoClose: 1500 });
            isLoadingRequest(false);
         } else {
            toast.success(`${requestData.length} Record(s) found `, { autoClose: 1500 });
            setRequests(requestData);
            isLoadingRequest(false);
         }
      } catch (error) {
         isLoadingRequest(false);
         toast.error('An error occurs', { autoClose: 1500 });
         console.dir(error);
      }
   };
   const fetchRequestsByMeter = async (formatedStartDate, formatedEndDate, searchKey, searchValue) => {
      isLoadingRequest(true);
      try {
         const result = await getRequestsByDatesAndMeter(formatedStartDate, formatedEndDate, searchKey, searchValue, 50);
         const requestData = await result.data.data;
         if (requestData.length === 0) {
            toast.info('No Records found', { autoClose: 1500 });
            isLoadingRequest(false);
         } else {
            toast.success(`${requestData.length} Record(s) found `, { autoClose: 1500 });
            setRequests(requestData);
            isLoadingRequest(false);
         }
      } catch (error) {
         isLoadingRequest(false);
         toast.error('An error occurs', { autoClose: 1500 });
         console.dir(error);
      }
   };

   return <MainContext.Provider value={{ requests, fetchRequests, fetchRequestsByMeter, loadingRequest }}>{props.children}</MainContext.Provider>;
};

// call get_subscriber_request('2020-09-21 00:00:00.0', '2020-09-25 23:59:59.0', '14235760049', 1);
